let isSended = false;

export default (sessionId, participantId) => {
  if (isSended) return;

  fetch('/api/scount/set-scount', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ParticipantId: participantId,
      SessionId: sessionId,
    }),
  });

  isSended = true;
};
